import 'details-polyfill';
import DetailsToggler from './DetailsToggler';

// First check if details el is natively supported
const details = document.querySelectorAll('.details');

for (let i = 0; i < details.length; i++) {
    new DetailsToggler(details[i]);
}
